
export default function ClearfieldNeighborhoods() {
  const neighborhoods = [
    {
      name: 'Hill Air Force Base Area',
      description: 'Rapid response for military families and base housing with specialized water damage restoration services.',
      icon: 'ri-plane-line'
    },
    {
      name: 'Clearfield Station',
      description: 'Serving the shopping district and surrounding residential areas with 24/7 emergency flood cleanup.',
      icon: 'ri-store-2-line'
    },
    {
      name: 'East Clearfield',
      description: 'Complete water damage restoration for East Clearfield homes and businesses near the foothills.',
      icon: 'ri-home-4-line'
    },
    {
      name: 'West Clearfield',
      description: 'Expert mold remediation and water damage services for West Clearfield neighborhoods.',
      icon: 'ri-community-line'
    },
    {
      name: 'Steed Creek',
      description: 'Trusted water damage restoration for Steed Creek area homes with fast emergency response.',
      icon: 'ri-water-percent-line'
    },
    {
      name: 'South Clearfield',
      description: 'Comprehensive disaster cleanup services for South Clearfield residential and commercial properties.',
      icon: 'ri-building-line'
    }
  ];

  return (
    <section className="py-12 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            Clearfield Neighborhoods We Serve
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            Fast water damage restoration response throughout all Clearfield areas
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {neighborhoods.map((neighborhood, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-5 md:p-8 shadow-sm hover:shadow-lg transition-all hover:-translate-y-1"
            >
              <div className="w-11 h-11 md:w-14 md:h-14 bg-sky-100 rounded-full flex items-center justify-center mb-4 md:mb-6">
                <i className={`${neighborhood.icon} text-xl md:text-2xl text-sky-600`}></i>
              </div>
              <h3 className="text-base md:text-xl font-bold text-gray-900 mb-2 md:mb-3">{neighborhood.name}</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">{neighborhood.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
